
const initialState = {
  businesses: [
    {
      _id: '1',
      name: 'KindCo',
      tagline: 'Helping communities grow',
      website: 'https://kindco.com',
      size: 'Small',
      associatedCauses: ['Youth', 'Education'],
      supportTypes: ['Financial Support', 'Volunteer Time'],
      location: { city: 'Wellington' },
      contact: {
        email: 'hello@kindco.com',
        phone: '0800 KINDCO',
        facebook: 'facebook.com/kindco',
        twitter: 'twitter.com/kindco',
        linkedin: 'linkedin.com/company/kindco'
      },
      helpDescription: 'We provide funding and volunteer support to youth programs.',
      businessValues: 'Community, sustainability, kindness',
      sponsorshipBlurb: 'We believe in giving back to local initiatives.',
      coverPhotoList: 'https://via.placeholder.com/600x300?text=KindCo+Banner',
      logoUrl: 'https://via.placeholder.com/100x100?text=KindCo'
    },
    {
      _id: '2',
      name: 'GreenBuilds',
      tagline: 'Sustainable building for tomorrow',
      website: 'https://greenbuilds.nz',
      size: 'Medium',
      associatedCauses: ['Environment', 'Housing'],
      supportTypes: ['Material Support', 'Financial Support'],
      location: { city: 'Auckland' },
      contact: {
        email: 'support@greenbuilds.nz',
        phone: '09 888 1234',
        facebook: 'facebook.com/greenbuilds',
        twitter: '',
        linkedin: 'linkedin.com/company/greenbuilds'
      },
      helpDescription: 'We sponsor eco-home builds and supply leftover materials to schools.',
      businessValues: 'Innovation, sustainability, housing equity',
      sponsorshipBlurb: 'We’re proud to back community projects that build the future.',
      coverPhotoList: 'https://via.placeholder.com/600x300?text=GreenBuilds+Cover',
      logoUrl: 'https://via.placeholder.com/100x100?text=GreenBuilds'
    }
  ]
}

const businessReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}

export default businessReducer
